import { useEffect } from "react";
import { useRef } from "react";
import DOMPurify from "dompurify";
import styles from "./id.module.css";
import parallax from "../parallax";

const Id = ({ textData ,setImgLoadComplate,language}) => {
  const text1 = useRef(null);
  const text2 = useRef(null);
  const img1ElementRef = useRef(null);
  const img2ElementRef = useRef(null);
  useEffect(() => {
    [text1.current, text2.current].forEach((item) => {
      parallax(
        {
          trigger: item,
          start: "top bottom",
          end: "top top",
          scrub: true,
        },
        item
      );
    });
  }, []);

  useEffect(() => {
    [img1ElementRef.current, img2ElementRef.current]
      .forEach((item) => {
        parallax(
          {
            trigger: item,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
          item,
          "px"
        );
      });
  }, []);
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData["text3"]),
        }}
      >
      </h1>
      <div className={styles.box}>
        <div className={styles.img1} >
          <img src="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-2.png" alt="ZHIYUN SMOOTH-Q4" ref={img1ElementRef} onLoad={() => {
            setImgLoadComplate(true)
          }}/>
          <div className={styles.imgBackground}></div>
        </div>
        <h5
          className={styles.text1}
          ref={text1}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text4"]),
          }}
        ></h5>
      </div>

      <div className={styles.box}>
        <h5
          className={styles.text2}
          ref={text2}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text5"]),
          }}
        ></h5>

        <div className={styles.img2}>
          <img src="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-3.png" alt="ZHIYUN SMOOTH-Q4"  ref={img2ElementRef} onLoad={() => {
            setImgLoadComplate(true)
          }}/>
          <div className={styles.imgBackground}></div>
        </div>
      </div>
    </div>
  );
};

export default Id;
